













































































































































































import { Ax } from '@/utils';
import { genListOfYears, variantForLimitIncome, variantName } from "@/modules/budget/budgetCorrectHelper";
import { getFromBackActualVariantByYear, loadVariantByUiid, loadVariantsByRegionCode } from "@/modules/budget/budgetVariantService";
import { CUR_YEAR } from "@/modules/budget-request/components/js/budgetCurYear";
import { BDropdown } from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import moment from 'moment';
import { Component, Vue } from "vue-property-decorator";
import DatePicker from 'vue2-datepicker';
import { FilterEventOwner } from '@/modules/budget/budget-correct/CorectHelper';

/**
 * Строка предпросмотра загрузки интеграции.
 *
 * ВНИМАНИЕ: имена `fact_as` и `utoch_pln` содержат опечатки - так называются
 * поля в ответе бэкенда (алиасы в SQL-запросе), менять их нельзя.
 */
interface IIntgrLoaderRow {
    cur_year?: number;
    gr?: number;
    abp?: number;
    prg?: number;
    ppr?: number;
    spf?: number;
    gu?: string;
    region?: string;
    kass_ras?: number;
    fact_as?: number;
    utoch_pln?: number;
    update_date?: string;
    user_id?: string;
    variant?: string;
}

interface IIntgrLoaderResponse {
    total: number;
    items: IIntgrLoaderRow[];
    delete_count: number;
}

/**
 * Самодостаточная страница «Загрузка интеграции».
 *
 * В отличие от CostCorrectSpf.vue (который получает obl/listReg/listVariants
 * пропсами от родителя BudgetCorrectMain.vue), этот компонент открывается
 * отдельным роутом и сам загружает все справочные данные, необходимые
 * блоку фильтров: код области инстанса, список регионов пользователя и
 * список версий бюджета по выбранному региону - теми же запросами/сервисами,
 * которые использует BudgetCorrectMain.vue.
 */
@Component({
    components: {
        'date-picker': DatePicker
    }
})
export default class IntgrLoading extends Vue {
    private loading = false;
    private tableLoading = false;
    private loadingInsert = false;
    private deleteExisting = false;

    private obl: string | null = null;
    private region: string = '';
    private curYear: number = CUR_YEAR + 1;
    private variant: string = '';
    private cashExpenseDate: Date | null = null;
    private correctedPlanDate: Date | null = null;

    private listReg: any[] = [];
    private listVariants: any[] = [];

    // Данные предпросмотра таблицы (POST /api-py/budget-intgr-loader/preview)
    private items: IIntgrLoaderRow[] = [];
    private total = 0;
    private deleteCount = 0;
    private deleteCountReady = false;
    private deleteCountLoading = false;
    private deleteCountRequestId = 0;
    private dataLoaded = false;

    private hide() {
        (this.$refs.drop as BDropdown).hide(true)
    }

    private get listOfYears() {
        return genListOfYears();
    }

    getVariantName(variant: any) {
        if (variant) {
            return variantName(variant);
        } else {
            return this.$t('modules.budget.intgr_loading.not_selected');
        }
    }

    /**
     * Список версий бюджета для селекта «Версия бюджета» - ВСЕ типы вариантов
     * (data_type 1/2/3/4) выбранного планового года по текущему региону, а не
     * только «Корректировка» (data_type=4), как было унаследовано от
     * CostCorrectSpf.vue (страницы именно корректировки бюджета).
     *
     * `variantForLimitIncome(listVariants, year, region)` без третьего параметра
     * `dataType` уже реализует ровно это: фильтр по `year`, `region_code === region`,
     * исключение удалённых (`is_deleted`) и сортировку по дате - готовый хелпер
     * из того же `budgetCorrectHelper.ts`, `listForCorrect` при этом не менялся
     * (он используется другими страницами - CostCorrectSpf.vue и др.).
     */
    private get listOfVariants() {
        return variantForLimitIncome(this.listVariants, this.curYear, this.region);
    }

    private get hasSelectedVariant(): boolean {
        return this.variant.trim().length > 0;
    }

    /**
     * Единый объект фильтра, который эмитится наружу через событие `change_filter`.
     * Собирается из всех полей блока фильтров, включая даты.
     */
    private get currentFilter() {
        return {
            variant: this.variant,
            year: this.curYear,
            region: this.region,
            cashExpenseDate: this.cashExpenseDate,
            correctedPlanDate: this.correctedPlanDate
        };
    }

    private formatDate(date: Date | null): string {
        if (!date) {
            return '';
        }
        return moment(date).format('DD.MM.YYYY');
    }

    private changeDateFilter() {
        this.resetTableData();
        this.$emit('change_filter', this.currentFilter);
        if (this.deleteExisting) {
            this.loadDeleteCount();
        }
    }

    /**
     * Сброс уже показанного результата предпросмотра (таблица + счётчик total) при смене
     * ЛЮБОГО параметра фильтра - период/регион/версия/обе даты. Сами значения фильтра
     * (curYear/region/variant/даты) не трогаются, очищается только устаревший результат,
     * чтобы пользователь не увидел строки, не соответствующие новому фильтру, пока не
     * нажмёт «Показать» заново.
     */
    private resetTableData() {
        this.items = [];
        this.total = 0;
        this.deleteCount = 0;
        this.deleteCountReady = false;
        this.deleteCountLoading = false;
        this.deleteCountRequestId++;
        this.dataLoaded = false;
    }

    private onDeleteExistingChange() {
        this.resetTableData();
        if (this.deleteExisting) {
            this.loadDeleteCount();
        }
    }

    private loadDeleteCount() {
        if (!this.curYear || !this.region || !this.hasSelectedVariant) {
            return;
        }
        const requestId = ++this.deleteCountRequestId;
        this.deleteCountLoading = true;
        Ax<number>(
            {
                url: '/api-py/budget-intgr-loader/delete-count',
                method: 'POST',
                data: { year: this.curYear, region: this.region, variant: this.variant },
                headers: this.buildAuthHeaders()
            },
            (count) => {
                if (requestId !== this.deleteCountRequestId) {
                    return;
                }
                this.deleteCount = count;
                this.deleteCountReady = true;
            },
            (error) => {
                if (requestId === this.deleteCountRequestId) {
                    this.makeToast('danger', this.$t('modules.budget.intgr_loading.load_error_title').toString(), error.toString());
                }
            },
            () => {
                if (requestId === this.deleteCountRequestId) {
                    this.deleteCountLoading = false;
                }
            }
        );
    }

    /**
     * Колонки таблицы предпросмотра - бюджетная классификация и суммы.
     * `gr`, `cur_year`, `variant`, `user_id`, `update_date` намеренно не выводятся.
     */
    private get tableFields() {
        return [
            { key: 'abp', label: this.$t('modules.budget.intgr_loading.table.abp') },
            { key: 'prg', label: this.$t('modules.budget.intgr_loading.table.prg') },
            { key: 'ppr', label: this.$t('modules.budget.intgr_loading.table.ppr') },
            { key: 'spf', label: this.$t('modules.budget.intgr_loading.table.spf') },
            { key: 'gu', label: this.$t('modules.budget.intgr_loading.table.gu') },
            { key: 'region', label: this.$t('modules.budget.intgr_loading.table.region') },
            { key: 'kass_ras', label: this.$t('modules.budget.intgr_loading.table.kass_ras'), class: 'text-right' },
            { key: 'fact_as', label: this.$t('modules.budget.intgr_loading.table.fact_as'), class: 'text-right' },
            { key: 'utoch_pln', label: this.$t('modules.budget.intgr_loading.table.utoch_pln'), class: 'text-right' }
        ];
    }

    /**
     * Текст бейджа над таблицей: количество записей и, если их больше отображаемых,
     * пометка о том, что показаны только первые N (N = фактическое число строк в `items`,
     * по контракту бэкенда - не более 100).
     */
    private get totalRecordsText(): string {
        if (this.total === 0) {
            return this.$t('modules.budget.intgr_loading.table_empty').toString();
        }
        const label = this.$t('modules.budget.intgr_loading.total_records_label').toString();
        const count = this.$n(this.total);
        if (this.total <= this.items.length) {
            return `${label}: ${count}`;
        }
        const shownLabel = this.$t('modules.budget.intgr_loading.shown_first_label').toString();
        return `${label}: ${count} — ${shownLabel} ${this.items.length}`;
    }

    /**
     * Кнопка «Загрузить» показывается только когда есть реальный смысл её нажимать:
     * предпросмотр уже выполнен и нашёл записи (`dataLoaded && total > 0`), и весь
     * фильтр заполнен (год/регион/версия/обе даты) - т.е. ровно те же параметры,
     * что уходят в `/api-py/budget-intgr-loader/load`.
     *
     * После `resetTableData()` (вызывается при смене любого параметра фильтра)
     * `dataLoaded` становится `false`, поэтому кнопка автоматически скрывается,
     * пока пользователь снова не нажмёт «Показать» и не получит записи.
     */
    private get canLoad(): boolean {
        return this.dataLoaded
            && (this.total > 0)
            && !!this.curYear
            && !!this.region
            && this.hasSelectedVariant
            && (this.cashExpenseDate !== null)
            && (this.correctedPlanDate !== null);
    }

    /**
     * Форматирование денежной суммы по принятому в проекте способу (`$n`, разделители разрядов).
     */
    private formatSum(value: number | null | undefined): string {
        if (value === null || value === undefined || isNaN(value)) {
            return '';
        }
        return this.$n(value);
    }

    /**
     * Заголовок авторизации для защищённых Keycloak-эндпоинтов `/preview` и `/load`.
     * `Ax` (в отличие от, например, глобального интерцептора) токен сам не добавляет,
     * поэтому передаём его явно - как и в `BudgetExecutionForm.vue` (`loadExecutors`).
     */
    private buildAuthHeaders() {
        return {
            Authorization: `Bearer ${this.$store.getters.token}`
        };
    }

    /**
     * Тело запроса, общее для предпросмотра (`/preview`) и реальной загрузки (`/load`) -
     * один и тот же набор параметров текущего фильтра.
     */
    private buildRequestPayload() {
        return {
            year: this.curYear,
            region: this.region,
            variant: this.variant,
            delete_existing: this.deleteExisting,
            cash_expense_date: this.cashExpenseDate ? moment(this.cashExpenseDate).format('YYYY-MM-DD') : null,
            corrected_plan_date: this.correctedPlanDate ? moment(this.correctedPlanDate).format('YYYY-MM-DD') : null
        };
    }

    private buildLoadPayload() {
        return {
            ...this.buildRequestPayload(),
            delete_existing: this.deleteExisting
        };
    }

    /**
     * Загрузка предпросмотра таблицы по кнопке - запрос тяжёлый (>10к строк),
     * поэтому не вызывается автоматически при каждом изменении фильтра.
     */
    private loadTableData() {
        if (!this.region || !this.hasSelectedVariant) {
            return;
        }
        this.tableLoading = true;
        Ax<IIntgrLoaderResponse>(
            {
                url: '/api-py/budget-intgr-loader/preview',
                method: 'POST',
                data: this.buildRequestPayload(),
                headers: this.buildAuthHeaders()
            },
            (data) => {
                this.total = data.total;
                this.items = data.items;
                this.deleteCount = data.delete_count || 0;
                this.deleteCountReady = this.deleteExisting;
                this.dataLoaded = true;
            },
            (error) => {
                this.makeToast('danger', this.$t('modules.budget.intgr_loading.load_error_title').toString(), error.toString());
            },
            () => {
                this.tableLoading = false;
            }
        );
    }

    /**
     * Текст диалога подтверждения реальной загрузки - показывает пользователю,
     * какие именно параметры фильтра будут использованы для вставки в БД.
     */
    private buildInsertConfirmMessage(): string {
        const planPeriod = `${this.curYear} - ${this.curYear + 2}`;
        const regionText = `${this.region} - ${this.getRegion(this.region).name_ru}`;
        const variantText = this.getVariantUidName(this.variant);
        return [
            this.$t(this.deleteExisting
                ? 'modules.budget.intgr_loading.load_confirm.delete_warning'
                : 'modules.budget.intgr_loading.load_confirm.warning').toString(),
            this.$t('modules.budget.intgr_loading.load_confirm.question').toString(),
            `${this.$t('modules.budget.intgr_loading.filter.filter_params.plan_period')}: ${planPeriod}`,
            `${this.$t('modules.budget.intgr_loading.filter.filter_params.region')}: ${regionText}`,
            `${this.$t('modules.budget.intgr_loading.filter.filter_params.version')}: ${variantText}`,
            ...(this.deleteExisting
                ? [`${this.$t('modules.budget.intgr_loading.delete_count_label')}: ${this.$n(this.deleteCount)}`]
                : []),
            `${this.$t('modules.budget.intgr_loading.filter.filter_params.cash_expense_date')}: ${this.formatDate(this.cashExpenseDate)}`,
            `${this.$t('modules.budget.intgr_loading.filter.filter_params.corrected_plan_date')}: ${this.formatDate(this.correctedPlanDate)}`
        ].join(' | ');
    }

    /**
     * Клик по кнопке «Загрузить» - обязательное подтверждение перед записью в БД
     * (в отличие от «Показать», которая только предпросмотр).
     */
    private async confirmAndInsert() {
        if (!this.region || !this.hasSelectedVariant) {
            return;
        }
        const confirmed = await this.$bvModal.msgBoxConfirm(this.buildInsertConfirmMessage(), {
            title: this.$t('modules.budget.intgr_loading.load_confirm.title').toString(),
            size: 'lg',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: this.$t('modules.budget.intgr_loading.insert_button').toString(),
            cancelTitle: this.$t('modules.budget.intgr_loading.load_confirm.cancel_title').toString(),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
        });
        if (confirmed) {
            this.insertData();
        }
    }

    /**
     * Реальная вставка данных в `budget_consolidate_calc_expens` через `/api-py/budget-intgr-loader/load`.
     * После успеха перезапускается предпросмотр - NOT EXISTS на бэке отсечёт уже загруженные строки,
     * и пользователь сразу увидит актуальный остаток (обычно 0).
     */
    private insertData() {
        if (!this.region || !this.hasSelectedVariant) {
            return;
        }
        this.loadingInsert = true;
        Ax<{ inserted: number; deleted?: number }>(
            {
                url: '/api-py/budget-intgr-loader/load',
                method: 'POST',
                data: this.buildLoadPayload(),
                headers: this.buildAuthHeaders()
            },
            (data) => {
                if (data.inserted === 0) {
                    const message = data.deleted
                        ? `${this.$t('modules.budget.intgr_loading.delete_success_label')}: ${this.$n(data.deleted)}. ${this.$t('modules.budget.intgr_loading.insert_nothing')}`
                        : this.$t('modules.budget.intgr_loading.insert_nothing').toString();
                    this.makeToast(
                        'info',
                        this.$t('modules.budget.intgr_loading.insert_nothing_title').toString(),
                        message
                    );
                } else {
                    this.makeToast(
                        'success',
                        this.$t('modules.budget.intgr_loading.insert_success_title').toString(),
                        [
                            `${this.$t('modules.budget.intgr_loading.insert_success_label')}: ${this.$n(data.inserted)}`,
                            data.deleted ? `${this.$t('modules.budget.intgr_loading.delete_success_label')}: ${this.$n(data.deleted)}` : ''
                        ].filter(Boolean).join('. ')
                    );
                }
                this.loadTableData();
            },
            (error) => {
                this.makeToast('danger', this.$t('modules.budget.intgr_loading.insert_error_title').toString(), error.toString());
            },
            () => {
                this.loadingInsert = false;
            }
        );
    }

    /**
     * 31 декабря (curYear - 2) - дефолт для "Дата кассовых расходов".
     *
     * Дата собирается явно по компонентам (год, месяц, день) через конструктор `Date`,
     * а не парсингом строки - это исключает смещение на день из-за часового пояса
     * (в отличие от `new Date('YYYY-MM-DD')`, которая трактуется как UTC-полночь).
     */
    private computeDefaultCashExpenseDate(year: number): Date {
        return new Date(year - 2, 11, 31);
    }

    /**
     * 31 марта (curYear - 1) - дефолт для "Дата уточнённого плана".
     * Собирается так же явно по компонентам даты, без парсинга строки/UTC.
     */
    private computeDefaultCorrectedPlanDate(year: number): Date {
        return new Date(year - 1, 2, 31);
    }

    /**
     * Пересчёт дефолтов обеих дат от переданного планового года.
     * Вызывается при инициализации страницы и при каждой смене года в фильтре -
     * ранее выбранные пользователем даты будут перезаписаны дефолтом для нового года
     * (так по ТЗ: год - основной параметр, даты всегда следуют за ним).
     */
    private applyDefaultDatesForYear(year: number) {
        this.cashExpenseDate = this.computeDefaultCashExpenseDate(year);
        this.correctedPlanDate = this.computeDefaultCorrectedPlanDate(year);
    }

    /**
     * Порядок инициализации данных страницы - как в BudgetCorrectMain.vue (родитель,
     * из которого делалась исходная страница CostCorrectSpf.vue):
     * область инстанса -> регион по умолчанию -> актуальный вариант этого региона ->
     * полный список версий бюджета -> справочник регионов пользователя (для селекта) ->
     * запасной подбор актуального варианта под текущий плановый период -> deep-link `?version=`.
     *
     * Регион нигде не хардкодится - он приходит из `/api-py/get-budget-obl/{instanceCode}`,
     * т.е. зависит от области конкретного инстанса (региона акимата), а не от константы.
     */
    async mounted() {
        this.loading = true;
        try {
            await this.loadObl();
            await this.loadVariantsList();
            await this.loadActualVariant();
            await this.loadRegions();
            if (this.region) {
                await this.find_actual_variant();
            }
            await this.variants_loaded();
        } finally {
            this.loading = false;
        }
    }

    created() {
        // Дефолты дат от текущего curYear - сразу при инициализации, чтобы
        // они были видны в хлебных крошках ещё до завершения загрузки справочников
        this.applyDefaultDatesForYear(this.curYear);
    }

    /**
     * Загрузка кода области инстанса и региона по умолчанию для неё.
     *
     * Аналог BudgetCorrectMain.vue -> getObl(): `json.obl` - код области, `json.region` -
     * регион по умолчанию для этой области (у BudgetCorrectMain.vue эта строка закомментирована,
     * но сам бэкенд `/api-py/get-budget-obl/{code}` реально возвращает `region` для каждого
     * инстанса - используем его, чтобы не хардкодить регион константой).
     */
    private async loadObl() {
        try {
            const response = await fetch('/api-py/get-budget-obl/' + this.$store.state._instanceCode);
            const json = await response.json();
            this.obl = json.obl;
            this.region = json.region;
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса getObl', String(error));
        }
    }

    /**
     * Определение актуального варианта бюджета для региона, полученного в `loadObl()`.
     *
     * Аналог шага `getActualVariant(this.region)` внутри BudgetCorrectMain.vue -> getObl().
     */
    private async loadActualVariant() {
        if (!this.region) {
            return;
        }
        try {
            const actualVariant = await getFromBackActualVariantByYear(this.region, this.curYear.toString());
            if (actualVariant) {
                this.variant = actualVariant;
            }
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса getActualVariant', String(error));
        }
    }

    /**
     * Загрузка списка регионов пользователя.
     *
     * Аналог BudgetCorrectMain.vue -> loadRegions()
     */
    private async loadRegions() {
        try {
            const response = await fetch(`/api-py/get-user-regions-by-obl/${this.obl}/${this.$store.getters.user_uuid}`);
            this.listReg = await response.json();
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса регионов', String(error));
        }
    }

    /**
     * Загрузка версий бюджета по текущему региону.
     *
     * Аналог BudgetCorrectMain.vue -> loadVariantsList(). Вызывается из `changeFilter()`
     * при смене И региона, И года (см. комментарий там) - в `BudgetCorrectMain.vue` этот
     * метод перезагружается через `changeChildFilter()` на любое изменение дочернего
     * фильтра, а не только на смену региона.
     */
    private async loadVariantsList() {
        if (!this.region) {
            this.listVariants = [];
            return;
        }
        try {
            this.listVariants = await loadVariantsByRegionCode(this.region);
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса loadVariantsList', String(error));
        }
    }

    /**
     * Инициализация фильтра из query-параметра `?version=` в URL (глубокая ссылка на версию бюджета)
     */
    private async variants_loaded() {
        const queryString = new URL(document.location.href.replace("#", "")).search;
        const params = new URLSearchParams(queryString);
        const version = params.get("version");
        if (!version) {
            return;
        }
        try {
            const variant = await loadVariantByUiid(version);
            if (variant) {
                this.curYear = variant.year;
                // Год изменился (пришёл из версии по глубокой ссылке) - пересчитываем дефолты дат
                this.applyDefaultDatesForYear(this.curYear);
                if (variant.region_code) {
                    this.region = variant.region_code;
                    await this.loadVariantsList();
                    this.variant = variant.variant_uuid;
                    this.$emit('change_filter', this.currentFilter);
                }
            }
        } catch (error) {
            this.makeToast('danger', 'Ошибка запроса variants_loaded', String(error));
        }
    }

    /**
     * Изменение фильтра пользователем (период / регион / версия).
     * Событие `change_filter` эмитится «на всякий случай» - если страницу когда-нибудь
     * встроят во внешний контейнер, но сама страница от этого слушателя не зависит.
     *
     * `loadVariantsList()` перезагружается и при смене региона, и при смене года - как
     * в эталоне `BudgetCorrectMain.vue` (`changeChildFilter()` перезагружает список версий
     * при ЛЮБОМ изменении дочернего фильтра, а не только при смене региона). См. подробный
     * разбор причины в комментарии к самому `loadVariantsList()`.
     */
    private async changeFilter(event_owner: FilterEventOwner) {
        this.resetTableData();
        if (event_owner === FilterEventOwner.year || event_owner === FilterEventOwner.region) {
            this.variant = "";
        }
        if (event_owner === FilterEventOwner.year) {
            // Смена планового периода - обе даты пересчитываются от нового curYear.
            // Дата, выбранная пользователем вручную для старого года, будет заменена дефолтом -
            // это осознанное поведение по ТЗ (год считается основным параметром для дат).
            this.applyDefaultDatesForYear(this.curYear);
        }
        if (event_owner === FilterEventOwner.year || event_owner === FilterEventOwner.region) {
            await this.loadVariantsList();
        }
        this.$emit('change_filter', this.currentFilter);
        await this.find_actual_variant();
        if (this.deleteExisting) {
            this.loadDeleteCount();
        }
    }

    private async find_actual_variant() {
        if (this.variant !== '' && this.variant !== null && this.variant !== undefined) {
            return;
        }
        for (const variant of this.listOfVariants.filter((value: any) => (value.year == this.curYear && value.region_code == this.region))) {
            if (variant.attribute) {
                this.variant = variant.variant_uuid;
            }
        }
    }

    private openFilterByRef(refName: string) {
        const drop: any = this.$refs.drop;
        drop.show(true);
        const refItem: any = this.$refs[refName];
        setTimeout(() => refItem.$el.focus(), 100);
    }

    getRegion(regCode: string) {
        const res = this.listReg.find((value: any) => value.code == regCode);
        if (res) {
            return res;
        } else {
            return {
                name_ru: this.$t('modules.budget.intgr_loading.not_selected')
            };
        }
    }

    private getVariantUidName(variant_uid: string) {
        const vr = this.listOfVariants.find((value: any) => value.variant_uuid == variant_uid);
        return this.getVariantName(vr)
    }

    private makeToast(variant: string, title: string, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }

}
